import type { HTMLAttributes } from "react";

import { XIcon } from "../../components";
import { cn } from "../../utils";

export type AlertCloseProps = HTMLAttributes<HTMLButtonElement>;

const Close = ({ children, className, ...props }: AlertCloseProps) => {
  return (
    <button className={cn("top-4 right-4 absolute", className)} {...props} type="button">
      {children || <XIcon className="w-5 h-5 min-w-[1.25rem]" />}
    </button>
  );
};

export default Close;
